module.exports = __webpack_public_path__ + "static/img/grzx.19a3f07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grzx.jpg
// module id = mD5K
// module chunks = 14